import './styles.scoped.css';

interface FooterProps {
};

const Footer: React.FC<FooterProps> = ({}) => {
  return (
    <footer className="footer">
      <div id="footertext">2025 TeamBit ©</div>
      <div id="footertext"><a href="/deklaracja.html" className="linkPP">Deklaracja Dostępności</a></div>
    </footer>
  );
}

export default Footer;
